import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { useCarousel } from "@repo/ui/carousel";
import { ImageWrapper } from "@/components/common/image/image.component";
import type { TenantDetailData } from "../tenant-detail-data";
import { PhotoAttribution } from "./photo-attribution.component";
type GooglePhotoRef = NonNullable<TenantDetailData["googlePhotos"]>[number];

// Google photo resource names expire, so the proxy resolves the current one
// from the place ID + index at request time (VAW-1707).
function placePhotoUrl(placeId: string, index: number): string {
  return `/api/place-photo?placeId=${encodeURIComponent(placeId)}&i=${index}`;
}
export function GooglePhotoSlide(t0) {
  const $ = _c(10);
  const {
    photo,
    placeId,
    index
  } = t0;
  const {
    selectedIndex
  } = useCarousel();
  let t1;
  if ($[0] !== index || $[1] !== placeId || $[2] !== selectedIndex) {
    t1 = <div className="h-[240px] w-[320px] tablet:h-[480px] tablet:w-[640px]">{selectedIndex === index ? <ImageWrapper visual={null} src={placePhotoUrl(placeId, index)} alt="" loading="lazy" unoptimized={true} sizes="(max-width: 768px) 320px, 640px" resizeMode="cover" className="size-full overflow-hidden rounded-sm tablet:rounded-md" /> : <div className="size-full rounded-sm bg-surface-base-secondary tablet:rounded-md" aria-hidden="true" />}</div>;
    $[0] = index;
    $[1] = placeId;
    $[2] = selectedIndex;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== photo.attribution || $[5] !== photo.attributionUri) {
    t2 = <PhotoAttribution attribution={photo.attribution} attributionUri={photo.attributionUri} />;
    $[4] = photo.attribution;
    $[5] = photo.attributionUri;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <figure className="flex h-full flex-col gap-2">{t1}{t2}</figure>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}